import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../AppContext";
import ProfileService from "../../services/ProfileService";
import './css/user-profile-comp.css';

const UserProfileComp = () => {
  const [appContext, setAppContext] = useContext(AppContext);
  const [userRepInfo, setUserRepInfo] = useState({ rriaAliases: "", repNumber: "" });
  const [userRole, setUserRole] = useState("");



  useEffect(() => {
    ProfileService.GetRepInfo()
      .then((result) => {
        setUserRepInfo(result);
      });

    ProfileService.GetUserRole()
      .then((result) => {
        setUserRole(result);
      });
  }, []);

  return (
    <section className="content-wrapper">
      <section>
        <div className="section-content">
          <div className="panel profile">
            <div className="panel-header">
              <div className="panel-header-label">Your User Profile</div>
            </div>
            <div className="panel-sub-header">
              <div className="message">If you need to update or change your profile details, contact the Compliance Department</div>
            </div>
            <div className="panel-body">
              <div className="panel-columns">
                
                <div className="panel-column">
                  <div className="panel-item">
                    <div className="panel-item-label">Name :</div>
                    <div className="panel-item-value">{appContext.user.userName}</div>
                  </div>

                  <div className="panel-item">
                      <div className="panel-item-label">Title :</div>
                      <div className="panel-item-value">{appContext.user.role}</div>
                  </div>

                  <div className="panel-item">
                      <div className="panel-item-label">User Id :</div>
                      <div className="panel-item-value">{appContext.user.userId}</div>
                  </div>

                  <div className="panel-item">
                    <div className="panel-item-label">Email :</div>
                    <div className="panel-item-value">{appContext.user.email}</div>
                  </div>

                </div>

                <div className="panel-column med">
                  <div className="panel-item">
                    <div className="panel-item-label">Organization Role :</div>
                    <div className="panel-item-value">{userRole}</div>
                  </div>

                  <div className="panel-item">
                      <div className="panel-item-label">Your RR Number(s) :</div>
                      <div className="panel-item-value">{userRepInfo.rriaAliases}</div>
                  </div>

                  <div className="panel-item">
                      <div className="panel-item-label">Your CRD Number :</div>
                      <div className="panel-item-value">{userRepInfo.repNumber}</div>
                  </div>

                  <div className="panel-item">
                    <div className="message">If you are Registered and have a RR or CRD Number, it will be displayed here</div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default UserProfileComp;
